/* eslint-disable @typescript-eslint/no-explicit-any */
import { ActionTree, GetterTree, MutationTree } from 'vuex';
import {
    ContactState,
    ContactFilter,
    ContactMutations,
    ContactActions,
    ContactGetters,
    SortMenuItem,
} from '@/types';

const getDefaultState = () => {
    return {
        search: null,
        sort: [],
        page: 1,
        filter: {
            health: null,
        },
    } as ContactState;
};

const state: ContactState = getDefaultState();

const mutations: MutationTree<ContactState> = {
    [ContactMutations.SET_SEARCH]: (state, search: string) => (state.search = search),
    [ContactMutations.SET_SORT]: (state, sort: SortMenuItem[]) => (state.sort = sort),
    [ContactMutations.SET_PAGE]: (state, page: number) => (state.page = page),
    [ContactMutations.SET_FILTER]: (state, filter: ContactFilter) => {
        state.filter = filter;
    },
};

const actions: ActionTree<ContactState, any> = {
    [ContactActions.SET_SEARCH]: ({ commit }, search: string) =>
        commit(ContactMutations.SET_SEARCH, search),
    [ContactActions.SET_SORT]: ({ commit }, sort: SortMenuItem[]) =>
        commit(ContactMutations.SET_SORT, sort),
    [ContactActions.SET_PAGE]: ({ commit }, page: number) =>
        commit(ContactMutations.SET_PAGE, page),
    [ContactActions.SET_FILTER]: ({ commit }, filter: ContactFilter) =>
        commit(ContactMutations.SET_FILTER, filter),
};

const getters: GetterTree<ContactState, any> = {
    [ContactGetters.SEARCH]: (state): string | null => state.search,
    [ContactGetters.SORT]: (state): SortMenuItem[] => state.sort,
    [ContactGetters.PAGE]: (state): number => state.page,
    [ContactGetters.FILTER]: (state): ContactFilter => state.filter,
};

export default {
    state,
    mutations,
    actions,
    getters,
};
